var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 66,
    viewBox: "0 0 61 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9006 25.3482C44.1957 25.3482 40.8211 26.9663 38.4398 29.5278C37.4476 30.6066 35.661 31.9548 33.7421 33.0336C34.6684 29.5278 37.447 25.2132 39.432 23.2584C41.9462 20.7641 43.4678 17.3257 43.4678 13.4832C43.4678 6.0672 37.6455 0.067416 30.5002 0C23.3548 0.0672462 17.5327 6.0672 17.5327 13.4832C17.5327 17.3261 19.0543 20.7641 21.5685 23.2584C23.5534 25.146 26.3321 29.5278 27.2583 33.0336C25.3399 31.8876 23.6194 30.6066 22.5607 29.5278C20.1789 26.9659 16.8048 25.3482 13.0999 25.3482C5.88845 25.3482 0 31.4154 0 38.8314C0 46.3145 5.88833 52.3146 13.0999 52.3146C16.8713 52.3146 20.1793 50.6964 22.5607 48.0672C23.6194 46.9212 25.4719 45.5053 27.5228 44.2921C27.3243 53.7978 22.8916 60.809 18.3264 63.573V66H42.6736V63.573C38.1084 60.8088 33.6757 53.7978 33.4772 44.2921C35.4622 45.5053 37.3806 46.9213 38.4393 48.0672C40.8211 50.6292 44.1952 52.3146 47.9001 52.3146C55.1115 52.3146 61 46.2474 61 38.8314C61.0005 31.4154 55.1782 25.3482 47.9001 25.3482H47.9006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerIcon);
export default __webpack_public_path__ + "static/media/flowerIcon.88c8796b43aa72790fd5b0c5d3bba3b2.svg";
export { ForwardRef as ReactComponent };